<template>
  <div class="col-12 prod-category active" :class="{ registered: categoryIsRegistered }">
    <div class="prod-category__category text-center">
      <img :src="getIconPath()" alt="" />
      {{ $t('step2.select_product_prefix') }} {{ $t('common.' + category.name) }}
      <button class="btn-edit-product-registration" @click.prevent="removeCategoryFromRegistered()" v-if="categoryIsRegistered">{{ $t('common.edit') }}</button>
      <button class="btn-edit-product-registration" @click.prevent="removeProduct()" v-if="categoryIsRegistered">{{ $t('common.delete') }}</button>
    </div>
    <div class="prod-category__category-form" :hidden="categoryIsRegistered">

      <div class="category-form__step1" :hidden="productIsSelected">
        <div class="row">

          <!-- <div v-if="selectProductOptions.length" class="offset-1 col-10 form-group">
            <label for="productFromCat-x">{{ $t('step2.select_product_list') }}:</label>
            <basic-select :options="selectProductOptions"
                    :selected-option="selectedProduct"
                    :placeholder="$t('step2.select_product')"
                    @select="onProductSelectChange">
            </basic-select>
            <div class="text-center mt-4 or-option">
              {{ $t('step2.or') }}
            </div>
          </div> -->
          
          <div class="offset-1 col-10 form-group">
            <label for="prod_name_finger">{{ $t('step2.prod_name_label') }}:</label>
            <input v-model="typedInProduct" @keyup="typedInProductChanged" type="text" class="form-control low" id="prod_name_finger" name="prod_name_finger" :placeholder="$t('step2.prod_name')">
          </div>

          <div class="offset-1 col-10 form-group text-right">
            <button @click.prevent="onProductSelectSubmit()" class="amica-btn amica-btn-red btn-next-step">{{ $t('step2.btn_select_product') }}</button>
          </div>

        </div>
      </div>

      <div class="category-form__step2" :hidden="!productIsSelected">
        <div class="row">

          <div class="offset-1 col-10  offset-xl-1 col-xl-6 prod__form">
            <h3>{{ $t('step2.form_heading') }}: <span class="form__prod-name">{{ selectedProduct.text || typedInProduct }}</span>
                  <span class="closeButton" @click="onUnselectProduct()" >x</span>
            </h3>

            <div class="row">
              <div class="col-12 form-group">
                <label for="serial_number_x">{{ $t('step2.serial_number') }}:</label>
                <input v-model="formData.serial" v-validate="'required|numeric|min:14'" type="text" class="form-control low" id="serial_number" name="serial_number" :placeholder="$t('step2.serial_number')" maxlength="14">
                <small>{{ errors.first('serial_number') }}</small>
              </div>
            </div>

            <div class="row">
              <div class="col-12 form-group">
                <label for="serial_number_x">{{ $t('step2.purchase_date') }}:</label>
                <datepicker v-model="formData.purchase_date" v-validate="'required|date_format:DD-MM-YYYY'" ref="purchase_date_dp" :language="datepickerLang" :input-class="'form-control low'" :format="'dd-MM-yyyy'" :disabledDates="datepickerConf.disabledDates" :placeholder="$t('step2.purchase_date')" name="purchase_date" ></datepicker>
                <div @click.prevent="openPurchaseDateDP()" class="calendar-ico">
                  <icon name="calendar-alt"></icon>
                </div>
                <small>{{ errors.first('purchase_date') }}</small>
              </div>
            </div>

            <div class="row">
              <div class="col-12 form-group">
                <label for="serial_number_x">{{ $t('step2.shop_type') }}:</label>
                <basic-select :options="shopTypeSelectOptions"
                  :selected-option="shopTypeSelected"
                  :placeholder="$t('step2.shop_type')"
                  @select="onShopTypeSelectChange">
                </basic-select>
              </div>
            </div>

            <div v-if="formData.shop_type === 'stationary'" class="row">
              <div class="col-12 form-group form-group-sub">
                <label for="serial_number_x">{{ $t('step2.shop_name') }}:</label>
                <input v-model="formData.shop_name" v-validate="requiredForStationaryShop ? 'required' : ''" key="shop_name" type="text" class="form-control low" id="shop_name" name="shop_name" :placeholder="$t('step2.shop_name')" >
                <small>{{ errors.first('shop_name') }}</small>
              </div>
            </div>

            <div v-if="formData.shop_type === 'stationary'" class="row">
              <div class="col-12 form-group form-group-sub">
                <label for="serial_number_x">{{ $t('step2.shop_address') }}:</label>
                <input v-model="formData.shop_address" v-validate="requiredForStationaryShop ? 'required' : ''" key="shop_address" type="text" class="form-control low" id="shop_address" name="shop_address" :placeholder="$t('step2.shop_address')" />
                <small>{{ errors.first('shop_address') }}</small>
              </div>
            </div>

            <div v-if="formData.shop_type === 'stationary'" class="row">
              <div class="col-12 form-group form-group-sub">
                <label for="serial_number_x">{{ $t('step2.shop_city') }}:</label>
                <input v-model="formData.shop_city" v-validate="requiredForStationaryShop ? 'required' : ''" key="shop_city" type="text" class="form-control low" id="shop_city" name="shop_city" :placeholder="$t('step2.shop_city')" >
                <small>{{ errors.first('shop_city') }}</small>
              </div>
            </div>
            
            <div v-if="formData.shop_type === 'stationary'" class="row">
              <div class="col-12 form-group form-group-sub">
                <label for="serial_number_x">{{ $t('step2.shop_zip_code') }}:</label>
                <input v-model="formData.shop_zip_code" v-validate="requiredForStationaryShop ? 'required' : ''" key="shop_zip_code" type="text" class="form-control low" id="shop_zip_code" name="shop_zip_code" :placeholder="$t('step2.shop_zip_code')" >
                <small>{{ errors.first('shop_zip_code') }}</small>
              </div>
            </div>

            <div v-if="formData.shop_type === 'online'" class="row">
              <div class="col-12 form-group form-group-sub">
                <label for="serial_number_x">{{ $t('step2.shop_www') }}:</label>
                <input v-model="formData.shop_www" v-validate="requiredForOnlineShop ? 'required' : ''" key="shop_www" type="text" class="form-control low" id="shop_www" name="shop_www" :placeholder="$t('step2.shop_www')" >
                <small>{{ errors.first('shop_www') }}</small>
              </div>
            </div>
            
            <div class="row">
              <div class="col-12 form-group">
                <span class="file-label">{{ $t('step2.doc_purchase') }}:</span>
                <file-upload
                  class="file-input"
                  :post-action="getPostAction()"
                  :data="{file_type: 'promotion_purchase_document'}"
                  extensions="gif,jpg,jpeg,png,webp,pdf"
                  accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                  :multiple="false"
                  :size="1024 * 1024 * 8"
                  v-model="purchaseFiles"
                  :input-id="getInputFileId('uploadPurchase')"
                  :ref="getInputFileId('uploadPurchase')"
                  @input-file="inputFile"
                  @input-filter="inputFilter">
                    <input v-model="purchaseInputFilename" v-validate="'required'" @click.prevent="handleFilePopup" type="text" class="form-control low fake-file-input" id="receipt_scan" name="receipt_scan" :placeholder="$t('step2.doc_purchase')">
                    <!-- <label class="label-reset" id="upload-purchase-label" v-bind:for="getInputFileId('uploadPurchase')">
                      
                    </label> -->
                    <div class="calendar-ico file-ico">
                        <icon name="upload"></icon>
                      </div>
                </file-upload>
                <small>{{ errors.first('receipt_scan') }}</small>
              </div>
            </div>

            <div class="row">
              <div class="col-12 form-group">
                <span class="file-label">{{ $t('step2.doc_warranty') }}:</span>
                <file-upload
                  :post-action="getPostAction()"
                  :data="{file_type: 'promotion_warranty_document'}"
                  extensions="gif,jpg,jpeg,png,webp,pdf"
                  accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                  :multiple="false"
                  :size="1024 * 1024 * 8"
                  v-model="warrantyFiles"
                  :input-id="getInputFileId('uploadWarranty')"
                  :ref="getInputFileId('uploadWarranty')"
                  @input-file="inputFile"
                  @input-filter="inputFilter">
                    <input v-model="warrantyInputFilename" v-validate="'required'" @click.prevent="handleFilePopup" type="text" class="form-control low fake-file-input" id="warranty_card" name="warranty_card" :placeholder="$t('step2.doc_warranty')">
                    <div class="calendar-ico file-ico">
                        <icon name="upload"></icon>
                      </div>
                    <!-- <label class="label-reset" id="upload-warranty-label" v-bind:for="getInputFileId('uploadWarranty')">
                      
                    </label> -->
                </file-upload>
                <small>{{ errors.first('warranty_card') }}</small>
              </div>
            </div>

            <div class="row">
              <div class="col-10 form-group mt-4">
                <button @click.prevent="onProductSubmit()" class="amica-btn amica-btn-red btn-next-step">регистрация на друг продукт</button>
                <br />
                <button @click.prevent="finishRegister()" class="amica-btn amica-btn-red btn-next-step mt-2">потвърждение на регистрацията</button>
              </div>
            </div>

          </div>

          <div class="d-none d-xl-block offset-1 col-3 py-5 prod-photo text-center">
            <img v-bind:src="productImageSauce()" alt="" class="img-fluid" />
            <div class="mt-2 text-center prod-photo__name">{{ selectedProduct.text }}</div>
          </div>

        </div>
      </div>

    </div>
    <div v-if="registeringLoader" class="registering-loader">
      <img src="@/assets/images/preloader-1.svg" alt="loading..." />
    </div>
  </div>
</template>

<script>
import {globalStore} from '@/main'
import { BasicSelect } from 'vue-search-select'
import Datepicker from 'vuejs-datepicker'
import {bg} from 'vuejs-datepicker/dist/locale'
import FileUpload from 'vue-upload-component'
import MaskedInput from 'vue-masked-input'

export default {
  name: 'step2CategoryBox',
  data () {
    return {
      datepickerLang: bg,
      datepickerConf: {
        disabledDates: {
          ranges: [
            {
              from: new Date(2000, 0, 1),
              to: new Date(2018, 7, 1)
            },
            {
              from: new Date(),
              to: new Date(2100, 0, 1)
            }
          ]
        }
      },

      formData: {
        prod_name: '',
        prod_id: '',
        serial: '',
        shop_type: '',
        purchase_date: '',
        shop_www: '',
        shop_name: '',
        shop_address: '',
        shop_city: '',
        shop_zip_code: '',
        category_id: this.category.id,
        purchase_document_orig_name: '',
        purchase_document_server_name: '',
        purchase_document_size: '',
        warranty_document_orig_name: '',
        warranty_document_server_name: '',
        warranty_document_size: ''
      },
      selectProductOptions: [],
      selectedProduct: {
        value: '',
        text: ''
      },
      typedInProduct: '',
      selectedProductData: {},
      productIsSelected: false,

      purchaseFiles: [],
      warrantyFiles: [],
      purchaseInputFilename: '',
      warrantyInputFilename: '',
      
      shopTypeSelectOptions: [
        {
          value: "stationary",
          text: this.$t('step2.list_element_offline')
        },
        {
          value: "online",
          text: this.$t('step2.list_element_online')
        }
      ],
      shopTypeSelected: {
        value: "",
        text: ""
      },
      registeringLoader: false
    }
  },
  props: ['category'],
  mounted () {
    this.fillProductsSelect()
  },
  computed: {
    categoryIsRegistered: function () {
      if (this.$store.getters.getRegisteredCategoriesIds.indexOf(this.category.id) > -1) {
        return true
      }
      return false
    },
    requiredForOnlineShop: function () {
      return this.formData.shop_type === 'online' ? true : false
    },
    requiredForStationaryShop: function () {
      return this.formData.shop_type === 'stationary' ? true : false
    },
  },
  methods: {
    getIconPath: function () {
      return require('@/assets/images/categories-icons/' + this.category.id + '.png')
    },
    fillProductsSelect: function () {
      let cmp = this
      let productsInCategory = cmp.$store.getters.getProducts[cmp.category.id]
      if (productsInCategory) {
        for (let i = 0; i < productsInCategory.length; i++) {
          cmp.selectProductOptions.push({
            value: productsInCategory[i].id,
            text: productsInCategory[i].symbol
          })
        }
      }
    },
    onProductSelectChange: function (item) {
      this.selectedProduct = item
      this.formData.prod_name = item.text
      this.typedInProduct = ''
    },
    typedInProductChanged: function () {
      this.selectedProduct = {
        value: '',
        text: ''
      }

    },
    onShopTypeSelectChange: function (item) {
      this.shopTypeSelected = item
      this.formData.shop_type = item.value
    },
    onProductSelectSubmit: function () {
      let cmp = this
      // select
      if (cmp.selectedProduct.value !== '') {
        let prodData = cmp.$store.getters.getProducts[cmp.category.id].find(function (product) {
          return product.id === cmp.selectedProduct.value
        })
        if (prodData) {
          cmp.selectedProductData = prodData
          cmp.formData.prod_id = prodData.id
        }
        cmp.productIsSelected = true
      } else if (cmp.typedInProduct.length !== 0) {
        cmp.selectedProductData = {
          symbol: cmp.typedInProduct,
          category_id: this.category.id
        }
        cmp.formData.prod_name = cmp.typedInProduct
        cmp.formData.prod_id = -1 * this.category.id //sztuczny id, potrzebny tylko w vuex jako identyfikator, nie zapisywany w bazie
        cmp.productIsSelected = true
      }
    },
    onUnselectProduct: function () {
        let cmp = this;
        
        for (let prop in cmp.formData) {
            if (cmp.formData.hasOwnProperty(prop)) {
                if (prop != 'category_id') {
                    cmp.formData[prop] = '';
                }
            }
        }
        cmp.productIsSelected = false;
    },
    productImageSauce: function () {
      if (this.selectedProductData) {
        return this.selectedProductData.image_url
      }
      return ''
    },
    handleFilePopup: function (event) {
      event.target.parentElement.querySelector('input[type="file"]').click()
    },
    onProductSubmit: function () {
      let cmp = this
      cmp.registeringLoader = true
      this.$validator.validateAll().then((result) => {
        if (result) {
          cmp.$store.dispatch('registerProduct', cmp.formData)
            .then(() => {
              this.$notify({
                text: this.$t('step2.notify_product_added'),
                type: 'success'
              })
              cmp.registeringLoader = false
            }).catch((errors) => {
              // cmp.$Progress.fail()
              console.log(errors)
            })
        } else {
          // if any validation errors
          console.log(result)
          cmp.registeringLoader = false
        }
      }).catch((err) => {
        console.log('VeeValidateErr: ' + err)
        cmp.registeringLoader = false
      })
    },
    finishRegister () {
      let cmp = this
      cmp.registeringLoader = true
      this.$validator.validateAll().then((result) => {
        if (result) {
          cmp.$store.dispatch('registerProduct', cmp.formData)
            .then(() => {
              this.$store.dispatch('finalizeRegistration').then((res) => {
                if (res.data.code === 200) {
                  this.$router.push('/product-registration/step-3')
                }
              })
            }).catch((errors) => {
              // cmp.$Progress.fail()
              console.log(errors)
            })
        } else {
          // if any validation errors
          console.log(result)
          cmp.registeringLoader = false
        }
      }).catch((err) => {
        console.log('VeeValidateErr: ' + err)
        cmp.registeringLoader = false
      })
    },
    removeCategoryFromRegistered: function () {
      this.$store.dispatch('unregisterProduct', this.formData.prod_id)
    },
    removeProduct: function () {
      this.$store.dispatch('unregisterProduct', this.formData.prod_id)
      this.$notify({
        text: this.$t('step2.notify_product_removed'),
        type: 'warn'
      })

      // :(
      this.formData = {
        prod_name: '',
        prod_id: '',
        serial: '',
        shop_type: '',
        purchase_date: '',
        shop_www: '',
        shop_name: '',
        shop_address: '',
        shop_city: '',
        shop_zip_code: '',
        category_id: this.category.id,
        purchase_document_orig_name: '',
        purchase_document_server_name: '',
        purchase_document_size: '',
        warranty_document_orig_name: '',
        warranty_document_server_name: '',
        warranty_document_size: ''
      }
      this.selectedProduct = {
        value: '',
        text: ''
      }
      this.selectedProductData = {}
      this.productIsSelected = false

      this.purchaseFiles = []
      this.warrantyFiles = []
      this.purchaseInputFilename = ''
      this.warrantyInputFilename = ''
      
      this.shopTypeSelectOptions = [
        {
          value: "stationary",
          text: this.$t('step2.list_element_offline')
        },
        {
          value: "online",
          text: this.$t('step2.list_element_online')
        }
      ]
      this.shopTypeSelected = {
        value: "",
        text: ""
      }
    },
    openPurchaseDateDP: function () {
      this.$refs.purchase_date_dp.showCalendar()
    },
    getInputFileId: function (id) {
      return id + '-' + this.category.id
    },
    getPostAction: function () {
      return globalStore.API_BASE_URL + 'files/upload'
    },
    inputFile: function (newFile) {
      if (newFile) {
        // if (newFile.id === this.getInputFileId('uploadPurchase')) {
        if (newFile.data.file_type === 'promotion_purchase_document') {
          this.purchaseInputFilename = newFile.name
          if (newFile.error === 'size') {
            alert('File size is too large. Max file size is 8MB.')
            this.purchaseInputFilename = ''
          }
          this.formData.purchase_document_orig_name = newFile.name
          this.formData.purchase_document_server_name = newFile.response
          this.formData.purchase_document_size = newFile.size
          this.$refs['uploadPurchase-' + this.category.id].active = true
        }
        if (newFile.data.file_type === 'promotion_warranty_document') {
          this.warrantyInputFilename = newFile.name
          if (newFile.error === 'size') {
            alert('File size is too large. Max file size is 8MB.')
            this.warrantyInputFilename = ''
          }
          this.formData.warranty_document_orig_name = newFile.name
          this.formData.warranty_document_server_name = newFile.response
          this.formData.warranty_document_size = newFile.size
          this.$refs['uploadWarranty-' + this.category.id].active = true
        }
      }
    },
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|gif|png|pdf)$/i.test(newFile.name)) {
          alert('Correct extensions: GIF, JPG, PNG, PDF')
          return prevent()
        }
      }
    },
    hasAnyPrize: function () {
      // if (this.$store.getters.getCurrentPrizeId !== null) {
      //   return true
      // }
      // return false
    },
    currentPrizeValue: function () {
      // return this.$store.getters.getCurrentPrizeValue
    }
  },
  filters: {
    lowercase: function (value) {
      return value.toLocaleLowerCase()
    }
  },
  components: {
    BasicSelect,
    Datepicker,
    FileUpload,
    MaskedInput
  }
}
</script>

<style lang="scss" scoped>
  .prod-category {
    border: 1px #d7dadf solid;
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 10px;
    opacity: .6;
    position: relative;

    &.active {
      opacity: 1;

      .prod-category__category {
        cursor: pointer;

        &:hover {
          background: darken(#dbdbdb, 10%);
        }
      }
    }

    &.registered {
      &:after {
        content: "✔";
        color: #fff;
        position: absolute;
        top: 0px;
        right: 0px;
        background: green;
        padding: 5px 14px 7px;
        text-align: center;
        font-size: 20px;
      }
    }

    .prod-category__category {
      width: 100%;
      background: #dbdbdb;
      padding-top: 30px;
      padding-bottom: 30px;
      color: #333;
      font-size: 14px;
      cursor: default;

      -webkit-transition: all .1s ease-in-out;
      -moz-transition: all .1s ease-in-out;
      -o-transition: all .1s ease-in-out;
      transition: all .1s ease-in-out;

      &:hover {
        background: #dbdbdb;
      }

      img {
        margin-right: 10px;
      }
    }

    .prod-category__category-form {

      .category-form__step1 {
        padding-top: 40px;
        padding-bottom: 10px;
      }

      .category-form__step2 {
        padding-top: 40px;
        padding-bottom: 10px;

        h3 {
          font-size: 24px;
          font-weight: 300;
          margin-bottom: 40px;
        }

        .file-label {
          display: inline-block;
          margin-bottom: 0.5rem;
        }

        span.file-uploads {
          width: 100%;
          text-align: left;
          height: 40px;
          border: 1px #ced4da solid;


        }

        label.label-reset {
          display: inline;
          margin-bottom: 0px;
          opacity: 1 !important;
          font-size: initial !important;

          label {
            display: none;
          }
        }

        .fake-file-input {
          cursor: pointer;
          position: static;
          height: 40px;
          width: 100%;
          opacity: 1;
          border: 0;
        }

        .calendar-ico {
          height: 38px;
          width: 38px;
          background: #e41429;
          position: absolute;
          bottom: 1px;
          right: 16px;
          cursor: pointer;

          &.file-ico {
            left: initial;
            right: 0px;
            bottom: 0px;
          }

          svg {
            fill: #fff;
            width: 100%;
            //height: 50%;
            margin-top: 12px;
          }
        }

        .prod__form {

          .form__prod-name {
            font-weight: 900;
            color: #e41429;
          }
        }

        .prod-photo {

          .prod-photo__name {
            font-size: 18px;
            font-weight: 900;
            color: #e41429;
          }
        }
      }
    }
  }

  .btn-edit-product-registration {
    // border: 1px #e41429 solid;
    border: none;
    background: rgba(255, 255, 255, .3);
    padding: 3px 10px;
    font-size: 11px;
    color: #e41429;
    margin-left: 10px;
    cursor: pointer;

    &:hover {
      background: #e41429;
      color: #fff;
    }
  }

  .btn-next-step {
    padding-left: 40px;
    padding-right: 40px;
  }

  .form-group-sub {
    padding-left: 30px;
    margin-left: 15px;
    padding-right: 30px;
    border-left: 3px #e41429 solid;
  }

  .or-option {
    font-size: 20px;
    color: #e41429;
    text-transform: uppercase;
  }

  .registering-loader {
    background: rgba(255, 255, 255, .5);
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 100;

    img {
      position: fixed;
      top: calc(50% - 10px);
      left: calc(50% - 80px);
    }
  }
  
  .closeButton {
    margin-left: 0em;
    padding: 0.5em; 
    font-size: 0.5em;
    color: grey;
    display: inline-block;
    cursor: pointer;
    vertical-align: super;
   }
   
   .closeButton:hover {
    color: #303030;
    outline: solid rgb(191, 222, 255) 2px;
    outline-offset: -5px;
   }
</style>
